export default __webpack_public_path__ + "1ca0ca72141bc0546f59b75d48c0115f.jpg";